module.exports = __webpack_public_path__ + "static/media/daxingchefuzhibanbiao.7a7bcf42.png";